function addGiftIdeaToCart(e) {
  if(e) {
    e.preventDefault();
  }

  e.target.setAttribute('disabled','disabled');
  e.target.classList.add('disabled');
  e.target.innerHTML = 'Adding...';

  var variantIds = e.target.getAttribute('data-variants').split('|||');
  var data = {'items': []};
  for(var i=0; i<variantIds.length; i++) {
    data.items.push({'id': variantIds[i], 'quantity': 1, 'properties': {'bulk-order':'false'}});
  }
  fetch(theme.routes.cartAdd, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data),
    credentials: 'same-origin'
  })
  .then(response => {
    window.location = '/collections/build-personalised-corporate-gifts';
  })
  .catch((error) => {
    e.target.removeAttribute('disabled');
    e.target.classList.remove('disabled');
    e.target.innerHTML = e.target.getAttribute('data-text');
    console.error('Error:', error);
  });
}

var giftIdeaButtons = document.querySelectorAll('.giftIdeaAddToCart'), giftIdeasLoop;

for (giftIdeasLoop = 0; giftIdeasLoop < giftIdeaButtons.length; giftIdeasLoop++) {
  giftIdeaButtons[giftIdeasLoop].onclick = addGiftIdeaToCart;
}

function absoluteSwatchClicked(element, colourName) {
  var parentBulkBlock = element.closest('.product-block').querySelector('.bulkOrderQuantities');
  console.log("1");
  console.log(colourName);
  if(parentBulkBlock) {
  console.log("2");
    // has bulk quantity inputs - display the relevant group:
    var allBulkVariantItems = parentBulkBlock.querySelectorAll('.bulkOrderQuantityItem');
    var i;
    for (i = 0; i < allBulkVariantItems.length; i++) {
      allBulkVariantItems[i].classList.remove('active');
    }
    var allRelevantBulkVariantItems = parentBulkBlock.querySelectorAll('.optionGroup'+colourName);
    for (i = 0; i < allRelevantBulkVariantItems.length; i++) {
      allRelevantBulkVariantItems[i].classList.add('active');
    }
  }
}



// function addBulkProcessing(parentForm, allActiveBulkVariantItems, wasAnUpdate) {
//     var data = {'items': []};
//   for (i = 0; i < allActiveBulkVariantItems.length; i++) {
//     data.items.push({'id': allActiveBulkVariantItems[i].getAttribute('data-variantid'), 'quantity': allActiveBulkVariantItems[i].value, 'properties': {'bulk-order':'true'}});
//   }
//   fetch(theme.routes.cartAdd, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify(data),
//     credentials: 'same-origin'
//   })
//   .then(response => {
//     if(wasAnUpdate) {
//     location.reload();
//   } else {
//   /*
//     // rebuild ajax cart:
//     document.dispatchEvent(new CustomEvent('ajaxProduct:added', {}));
//     // close modal:
//     if(document.querySelector('#ProductModals .modal--is-active .js-modal-close')) {
//       document.querySelector('#ProductModals .modal--is-active .js-modal-close').click();
//     }
//     */
//     // need reload to allow the edit feature to work correctly:
//     location.reload();
//   }
    
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   });
//   return false;
// }

function addBulkProcessing(parentForm, allActiveBulkVariantItems, wasAnUpdate) {
  var data = {'items': []};
  for (var i = 0; i < allActiveBulkVariantItems.length; i++) {
    data.items.push({
      'id': allActiveBulkVariantItems[i].getAttribute('data-variantid'),
      'quantity': allActiveBulkVariantItems[i].value,
      'properties': {'bulk-order': 'true'}
    });
  }
  fetch(theme.routes.cartAdd, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
    credentials: 'same-origin'
  })
  .then(response => response.json())
  .then(data => {
    if (data.status) {
      // Handle error (e.g., out of stock)
      console.error('Add to cart error:', data.message);
      return;
    }

    // Update cart UI (mobile cart)
    return theme.cart.getCartProductMarkup().then(markup => {
      // Update mobile cart UI (adjust selector as needed)
      const cartDrawer = document.querySelector('.cart-drawer'); // Example selector
      if (cartDrawer) {
        cartDrawer.innerHTML = markup;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {}));
      }

      // Close modal if open
      const modalClose = document.querySelector('#ProductModals .modal--is-active .js-modal-close');
      if (modalClose) {
        modalClose.click();
      }

      // Redirect to lastCollection
      let collectionSlug = localStorage.getItem('lastCollection');
      if (!collectionSlug) {
        collectionSlug = 'all'; // Fallback
      }
      let returnPath = '/collections/' + collectionSlug;

      if (localStorage.getItem("fromBulkOrder") === 'false') {
        returnPath = '/collections/build-personalised-corporate-gifts';
      }

      console.log('Redirecting to:', returnPath);
      window.location.href = returnPath;
    });
  })
  .catch(error => {
    console.error('Error:', error);
  });
  return false;
}

function addBulkQuantitysToOrder(element) {
  // find the active quantities:
  var parentForm = element.closest('.productBlocksWrapper');
  var allActiveBulkVariantItems = parentForm.querySelectorAll('.bulkOrderQuantityItem.active input');
  var i;

  if(element.getAttribute('data-lineItemToRemove') != 'null') {
      // remove this existing line:
  var data = {'updates': {}};

  var lineItemToRemove = element.getAttribute('data-lineItemToRemove');

  data['updates'][lineItemToRemove] = 0;

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data),
    credentials: 'same-origin'
  })
  .then(response => {
addBulkProcessing(parentForm, allActiveBulkVariantItems, true);

  })
  .catch((error) => {
    console.error('Error:', error);
  });
  } else {
    addBulkProcessing(parentForm, allActiveBulkVariantItems, false);
  }



}


// basically a clone of CollectionSidebar from theme.js:
  theme.SwagCartSidebar = (function() {
    var selectors = {
      sidebarId: 'swagForm',
      trigger: '.collection-filter__button',
      mobileWrapper: '.swag-wrapper',
      filters: '.swag__item--cart',
      filterBar: '.collection-filter'
    };
  
    var config = {
      isOpen: false,
      namespace: '.swagFormWrapper'
    }
  
    function SwagCartSidebar() {
      // Do not load when no sidebar exists
      if(!document.getElementById(selectors.sidebarId)) {
        return;
      }
  
      document.addEventListener('categories:open', this.instantClose.bind(this));
      document.addEventListener('cart:open', this.open.bind(this));
      this.init();
    }
  
    function getScrollFilterTop() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var elTop = document.querySelector(selectors.filterBar).getBoundingClientRect().top;
      return elTop + scrollTop;
    }
  
    // Set a max-height on drawers when they're opened via CSS variable
    // to account for changing mobile window heights
    function sizeDrawer() {
      var header = document.getElementById('HeaderWrapper').offsetHeight;
      var filters = document.querySelector(selectors.filterBar).offsetHeight;
      var max = window.innerHeight - header - filters;
      document.documentElement.style.setProperty('--cartMaxFiltersHeight', `${max}px`);
    }
  
    SwagCartSidebar.prototype = Object.assign({}, SwagCartSidebar.prototype, {
      init: function() {
        config.isOpen = false;
        theme.a11y.unlockMobileScrolling(config.namespace);
  
        // This function runs on page load, and when the collection section loads
        // so we need to be mindful of not duplicating event listeners
        this.container = document.getElementById(selectors.sidebarId);
        this.trigger = document.querySelector(selectors.trigger);
        this.wrapper = document.querySelector(selectors.mobileWrapper);
        this.filters = this.wrapper.querySelector(selectors.filters);
  
        this.trigger.off('click');
        this.trigger.on('click', this.toggle.bind(this));
      },
  
      /*============================================================================
        Open and close filter drawer
      ==============================================================================*/
      toggle: function() {
        if (config.isOpen) {
          this.close();
        } else {
          this.open();
        }
      },
  
      open: function() {
        sizeDrawer();
  
        // Scroll to top of filter bar when opened
        var scrollTo = getScrollFilterTop();
        window.scrollTo({top: scrollTo, behavior: 'smooth'});
  
        this.trigger.classList.add('is-active');

        document.dispatchEvent(new Event('swagCart:open'));
  
        theme.utils.prepareTransition(this.filters, function() {
          this.filters.classList.add('is-active');
        }.bind(this));
        config.isOpen = true;
  
        theme.a11y.lockMobileScrolling(config.namespace);
  
        window.on('keyup' + config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
      },
  
      close: function() {
        this.trigger.classList.remove('is-active');
  
        theme.utils.prepareTransition(this.filters, function() {
          this.filters.classList.remove('is-active');
        }.bind(this));
        config.isOpen = false;
  
        theme.a11y.unlockMobileScrolling(config.namespace);
  
        window.off('keyup' + config.namespace);
      },

      instantClose: function() {
        // Absolute addition
        this.trigger.classList.remove('is-active');
        this.filters.classList.remove('is-active');
        config.isOpen = false;
        theme.a11y.unlockMobileScrolling(config.namespace);
        window.off('keyup' + config.namespace);
      },
  
      onSelect: function() {
        this.open();
      },
  
      onDeselect: function() {
        this.close();
      }
    });
  
    return SwagCartSidebar;
  })();

function absoluteInitPackItemButton() {
  // set up mobile cart:
  new theme.SwagCartSidebar();
}

absoluteInitPackItemButton();

function getHeaderSize() {
  var headerHeight = document.getElementById('HeaderWrapper').offsetHeight;
  var filterHeight = 0;
  if(document.getElementById('filterToolbar')) {
    filterHeight = document.getElementById('filterToolbar').offsetHeight;
  }
  document.documentElement.style.setProperty('--headerHeight', headerHeight + 'px');
  var cartDrawerHeight = (headerHeight + filterHeight);
  document.documentElement.style.setProperty('--cartMaxDrawerHeight', cartDrawerHeight + 'px');
  // force it with JS for iOS:
  var remainingHeight = window.innerHeight - cartDrawerHeight;
  if(document.getElementById('swagCartContents')) {
    document.getElementById('swagCartContents').style.maxHeight = remainingHeight + 'px';
  }
}

window.on('resize', theme.utils.debounce(300, function() {
  getHeaderSize();
}));
getHeaderSize();



/*
function checkContactValue(e) {
  if(e.target.value == "Other") {
    document.getElementById('ContactFormLookingForAdditionalWrapper').style.display = 'block';
  } else {
    document.getElementById('ContactFormLookingForAdditionalWrapper').style.display = 'none';
  }
}

function setUpContactForm() {
  document.getElementById('ContactFormLookingFor').onchange = checkContactValue;
}

if(document.getElementById('ContactFormLookingFor')) {
  setUpContactForm();
}
*/


function editCartSubmit(thisElem) {
  var selectedVariant = thisElem.closest('.product-single__form').querySelector('.product-single__variants').value;
  var selectQuantity = thisElem.closest('.productBlocksWrapper').querySelector('.js-qty__num').value;
  var lineItemToRemove = thisElem.getAttribute('data-initialvariant');
  var isBulkOrder = thisElem.getAttribute('data-bulkorder');

  thisElem.setAttribute('disabled','disabled');
  thisElem.classList.add('disabled');
  thisElem.innerHTML = 'Updating...';

  // remove this existing line:
  var data = {'updates': {}};

  data['updates'][lineItemToRemove] = 0;

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data),
    credentials: 'same-origin'
  })
  .then(response => {
    // add in the new:


    var data = {'items': []};
    data.items.push({'id': selectedVariant, 'quantity': selectQuantity, 'properties': {'bulk-order': isBulkOrder}});

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
      credentials: 'same-origin'
    })
    .then(response => {
      location.reload();
    })
    .catch((error) => {
      e.target.removeAttribute('disabled');
      e.target.classList.remove('disabled');
      e.target.innerHTML = e.target.getAttribute('data-text');
      console.error('Error:', error);
    });

    // end add in the new

  })
  .catch((error) => {
    thisElem.removeAttribute('disabled');
    thisElem.classList.remove('disabled');
    thisElem.innerHTML = e.target.getAttribute('data-default-text');
    console.error('Error:', error);
  });
}